export default __webpack_public_path__ + "static/media/csvUploadIcon.60c6f302.svg";